import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseSupplierProduct } from "./UseSupplierProduct";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import SupplierProduct from "./SupplierProduct";
import SupplierBrand from "./SupplierBrand";

export default function EditSupplierProducts() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [supplierProduct, setSupplierProduct] = useState();
  const { getSupplierByID } = UseSupplierProduct();
  const [showProducts, setShowProducts] = useState(false);
  const [showBrands, setShowBrands] = useState(false);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [state, setState] = useState({
    id: undefined,
    companyName: undefined,
    visitor: undefined,
    visitorMobile: undefined,
    companyMobile: undefined,
    productCount: undefined,
    isEnable: false,
  });

  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state.id) {
      setProgress(true);
      getSupplierByID(location.state.id, (supplierProductRes) => {
        setState(supplierProductRes);
      });
    }
  }, []);

  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/supplierProducts" },
          {
            name: "ویرایش محصول تامین کننده",
            url: "/supplierProducts/editSupplierProduct",
          },
        ],
      }}
    >
      {!supplierProduct ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.companyName ? state.companyName : ""}
              label="نام شرکت"
              size="small"
              variant="filled"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.visitor ? state.visitor : "-"}
              label="نام ویزیتور"
              size="small"
              variant="filled"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <TextField
              fullWidth
              id="filled-basic"
              value={state.visitorMobile ? state.visitorMobile : ""}
              sx={{
                input: { direction: "rtl" },
              }}
              label="شماره ویزیتور"
              variant="filled"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <TextField
              fullWidth
              id="filled-basic"
              value={state.companyMobile ? state.companyMobile : "-"}
              sx={{
                input: { direction: "rtl" },
              }}
              label="شماره شرکت"
              variant="filled"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 2"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <TextField
              fullWidth
              id="filled-basic"
              value={state.productCount ? state.productCount : 0}
              sx={{
                input: { direction: "rtl" },
              }}
              label="تعداد محصولات"
              variant="filled"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 2"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <TextField
              fullWidth
              id="filled-basic"
              value={state.brandCount ? state.brandCount : 0}
              sx={{
                input: { direction: "rtl" },
              }}
              label="تعداد برند ها"
              variant="filled"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <FormControlLabel
              disabled
              checked={state.isEnable}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فعال"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 2 }}
            gridColumn={isSmall ? "span 12" : "span 3"}
          >
            <Button
              onClick={() => setShowProducts(true)}
              variant="contained"
              color="info"
              sx={{
                width: "100px",
              }}
            >
              فیلتر محصول
            </Button>
            <Button
              onClick={() => setShowBrands(true)}
              variant="contained"
              color="warning"
              sx={{
                width: "100px",
              }}
            >
              فیلتر برند
            </Button>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end" }}
            gridColumn="span 3"
          >
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/supplierProducts", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
      {showProducts && (
        <SupplierProduct
          setShowProducts={setShowProducts}
          showProducts={showProducts}
          SupplierID={state.id}
          callback={(id) => {
            setProgress(true);
            getSupplierByID(id, (supplierProductRes) => {
              setState(supplierProductRes);
            });
          }}
        />
      )}
      {showBrands && (
        <SupplierBrand
          setShowBrands={setShowBrands}
          showBrands={showBrands}
          SupplierID={state.id}
          callback={(id) => {
            setProgress(true);
            getSupplierByID(id, (supplierProductRes) => {
              setState(supplierProductRes);
            });
          }}
        />
      )}
    </Detail>
  );
}
